import { Box, Typography } from "@mui/material";
import { AttributeDetails } from "../mui-components/AttributeValueBox";
import Utils from "../util/Utils";
import { useSnapshot } from "valtio";
import { viewBookingStore } from "../state/CommonState";
import { dsrstatic_cn } from "../my-actions/dsr_static";
import { Title } from "@mui/icons-material";
import { ServerLists } from "../StaticData";





export function CustomsDetail() {
    const booking = viewBookingStore.current;
    return <Box sx={{ display: "flex", flexDirection: "column", gap: 1, paddingX: "10px" }}>
        <Typography sx={{ fontSize: "16px", fontWeight: "bold", fontFamily: "Figtree", color: "black" }}>Export Clearance ({Utils.extractCountry(booking.origin)})</Typography>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            <AttributeDetails details={booking?.exportClearance?.map((exportdetail) => (
                {
                    title: exportdetail.label,
                    value: Utils.isValidDate1(Utils.dateConversion(exportdetail.value)) ?
                        Utils.formatDateBooking(Utils.dateConversion(exportdetail.value), false)
                        : exportdetail.value
                }
            ))} />
        </Box>
        <Typography sx={{ fontSize: "16px", fontWeight: "bold", fontFamily: "Figtree", color: "black" }}>Import Clearance ({Utils.extractCountry(booking.destination)})</Typography>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            <AttributeDetails details={booking?.importClearance?.map((exportdetail) => (
                {
                    title: exportdetail.label,
                    value:
                        Utils.isValidDate1(Utils.dateConversion(exportdetail.value)) ?
                            Utils.formatDateBooking(Utils.dateConversion(exportdetail.value), false)
                            : exportdetail.value

                }
            ))} />
        </Box>
    </Box>
}
